import type { NavigationScreen } from 'app/types/navigation';
import type { ComponentProps, FC } from 'react';
import { AllNotificationsContent } from './all-notifications-content';

type AllNotificationsScreenComponentProps = ComponentProps<NavigationScreen<'all-notifications'>> & {
  isDesktop: boolean;
};

export const AllNotificationsScreenComponent: FC<AllNotificationsScreenComponentProps> = () => (
  <AllNotificationsContent screenName="AllNotificationsScreen" />
);
